import React from 'react';
import { IExtendedMessage } from 'interfaces/message-interfaces';

export function DeleteSubscriberTag({ message }: { message: IExtendedMessage }) {
  return <div>Delete Subscriber</div>;
}
